<div class="ngx-bottom-nav-button" [routerLink]="routerLink" [class.label-hidden]="hideLabel">
  <!-- routerLinkActive="active" -->
  <!-- [routerLinkActiveOptions]="{ exact: exact }" -->
  <ng-content select="[ngxBottomNavIcon]"></ng-content>
  <div class="label">{{ label }}</div>
</div>
